<template>
  <div>
    <div style="padding: 20px; text-align: right">
      <span style="font-size: 110%" v-if="user">{{ user.email }}</span> [<a
        @click="doSignOut()"
        href="javascript:void(0)"
        >Sair</a
      >]
    </div>

    <section id="plan-selection">
      <p class="step-info">PASSO 2 DE 3</p>
      <h3 class="step-description">Escolha o melhor plano para você</h3>

      <br />
      <br />

      <div class="plan-buttons">
        <div class="buttons">
          <label
            v-for="plan in plans"
            :key="plan.id"
            @click="onClickSelectPlan(plan)"
            :class="{
              active: selectedPlan && selectedPlan.id === plan.id,
            }"
          >
            <span>{{ plan.shortReason }}</span>
          </label>
        </div>
      </div>

      <table>
        <tbody>
          <tr>
            <td class="first">Preço por mês</td>
            <td
              v-for="plan in plans"
              :key="plan.id"
              :class="{
                'is-selected': selectedPlan && selectedPlan.id === plan.id,
              }"
            >
              {{ plan.monthlyFee | currency }}
            </td>
          </tr>

          <tr>
            <td class="first">Máx. de pedidos/mês</td>
            <td
              v-for="plan in plans"
              :key="plan.id"
              :class="{
                'is-selected': selectedPlan && selectedPlan.id === plan.id,
              }"
            >
              {{ plan.maxPickers ? plan.maxOrders : "Ilimitado" }}
            </td>
          </tr>

          <tr>
            <td class="first">Máx. de pickers</td>
            <td
              v-for="plan in plans"
              :key="plan.id"
              :class="{
                'is-selected': selectedPlan && selectedPlan.id === plan.id,
              }"
            >
              {{ plan.maxPickers ? plan.maxPickers : "Ilimitado" }}
            </td>
          </tr>
        </tbody>
      </table>

      <div class="container-button">
        <v-btn
          @click="doPlanSelection(selectedPlan)"
          block
          large
          :loading="loading"
          color="success"
          type="submit"
          >Ir para o pagamento</v-btn
        >
      </div>
    </section>
  </div>
</template>

<script>
import { plansCollection } from "@/services/firestore-service";
import { createPendingSubscription } from "@/services/subscription";

export default {
  data() {
    return {
      plans: [],
      selectedPlan: {},
      loading: false,
    };
  },

  props: ["user"],

  methods: {
    onClickSelectPlan(plan) {
      this.$data.selectedPlan = plan;
    },

    async doPlanSelection(plan) {
      this.$data.loading = true;
      try {
        const result = await createPendingSubscription({
          planId: plan.id,
          payerEmail: this.user.email
        });
        const mpRedirectURL = result.data.redirect;
        window.location.href = mpRedirectURL;
      }catch(e) {
        this.$data.loading = false;
        console.log({e});
        alert('Houve um erro na requisição. Tente novamente.')
      }
    },

    doSignOut() {
      this.$emit("signOut");
    },
  },

  mounted() {
    plansCollection.get().then((querySnapshot) => {
      this.$data.plans = [];
      querySnapshot.docs.forEach((docSnapshot, index) => {
        const planData = docSnapshot.data();
        planData.id = docSnapshot.id;
        planData.isFeatured = index == 1;
        this.$data.plans.push(planData);
      });
      this.$data.selectedPlan = this.$data.plans[1];
    });
  },
};
</script>

<style lang="scss" scoped>
$primary-dark: darken(#00ccff, 10%);
$secondary-dark: #000;

#plan-selection {
  padding: 80px 16vw;
  max-width: 70vw;

  .plan-buttons {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-end;

    .buttons {
      display: flex;
      justify-content: space-around;
      align-items: center;
      order: 1;
      width: 60%;
      height: 80px;
      margin-bottom: 20px;

      label {
        flex: 1;
        text-align: center;
        padding: 20px;
        user-select: none;
        cursor: pointer;

        span {
          display: block;
          padding: {
            top: 10px;
            bottom: 10px;
          }
          width: 100%;
          background-color: $secondary-dark;
          color: #fff;
        }

        &.active {
          span {
            background-color: $primary-dark;
          }
        }
      }
    }
  }

  table {
    border-collapse: collapse;
    width: 100%;

    tbody {
      td {
        border-bottom: 1px solid #333;
        padding: 12px 16px;
        font-size: 16px;
        width: calc(60% / 3);
        text-align: center;
        font-weight: 500;
        &.first {
          text-align: left;
          width: 40%;
          font-weight: initial;
        }

        &.is-selected {
          color: $primary-dark;
        }
      }
    }
  }

  .container-button {
    width: 100%;
    display: flex;
    justify-content: center;
    margin: 40px 0;

    button {
      width: 70%;
      height: 40px;
      font-weight: normal;
      font-size: 16px;
      background-color: $primary-dark;
    }
  }
}
</style>